export default __webpack_public_path__ + "static/media/icon_close.4c5d5810.svg";